module.exports = __webpack_public_path__ + "img/case-bj2.e20cecc4.png";